import React, {Fragment} from "react";
import {Box, Grid, Paper, Skeleton, useTheme} from "@mui/material";

const GridItemSkeleton = () =>{
    const themeMUI = useTheme();
    return <Grid item xs={12} sm={6} lg={4}>
        <Box>
            <Paper square elevation={0}>
                <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
                    <Box sx={{ marginRight: themeMUI.spacing(1) }}>
                        <Skeleton variant="circular" height="32px" width="32px" animation={"wave"} />
                    </Box>
                    <Skeleton width={"100%"} height={themeMUI.spacing(3)} animation={"wave"}>

                    </Skeleton>
                </Box>

                <Box sx={{ paddingTop: "100%", position: "relative" }}>
                    <Skeleton sx={{ position: "absolute", top: 0 }} height="100%" variant="square" width="100%" animation={"wave"} />
                </Box>
                <Box pt={2} >
                    <Box display="flex" width={"100%"}>
                        <Grid container spacing={1} flexDirection={'row'} flexWrap={'nowrap'}>
                            {
                                [0, 1, 3, 4].map((product, index) => {

                                    return <Grid item xs={6} key={index+product} sx={{minWidth: '25%'}}>
                                        <Box paddingTop={'100%'} position={'relative'}>
                                            <Skeleton width={"100%"} height={'100%'} sx={{position: 'absolute', top:0}} variant={'rectangular'} animation={"wave"} />
                                        </Box>
                                        <Box>
                                            <Skeleton width={"100%"} height={themeMUI.spacing(3)} animation={"wave"} />
                                        </Box>
                                    </Grid>
                                })
                            }
                        </Grid>
                    </Box>
                </Box>
                <Box >
                    <Skeleton width={"50%"} height={themeMUI.spacing(3)} animation={"wave"} />
                    <Skeleton width={"100%"} height={themeMUI.spacing(3)} animation={"wave"} />
                </Box>

            </Paper>
        </Box>
    </Grid>

}

export default GridItemSkeleton;